const map = {
	"./1.png": "./src/assets/images/dashboard-2/order/sub-product/1.png",
	"./10.png": "./src/assets/images/dashboard-2/order/sub-product/10.png",
	"./2.png": "./src/assets/images/dashboard-2/order/sub-product/2.png",
	"./3.png": "./src/assets/images/dashboard-2/order/sub-product/3.png",
	"./4.png": "./src/assets/images/dashboard-2/order/sub-product/4.png",
	"./5.png": "./src/assets/images/dashboard-2/order/sub-product/5.png",
	"./6.png": "./src/assets/images/dashboard-2/order/sub-product/6.png",
	"./7.png": "./src/assets/images/dashboard-2/order/sub-product/7.png",
	"./8.png": "./src/assets/images/dashboard-2/order/sub-product/8.png",
	"./9.png": "./src/assets/images/dashboard-2/order/sub-product/9.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/dashboard-2/order/sub-product sync recursive ^\\.\\/.*$";